import { useAtomValue } from 'jotai';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { Link } from '@consumer-frontend/shared-ui';

import { isApplyVariantAtom } from '../../store';

import '@consumer-bootstrap/brands/netcredit/footer.scss';
import '@consumer-bootstrap/netcredit.scss';

export const NcDisclaimerText = () => {
  const showApplyDisclaimer = useAtomValue(isApplyVariantAtom);

  return (
    <div className="disclaimers">
      {
        showApplyDisclaimer && (
          <>
            <p>
              <strong>IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT OR APPLYING FOR A LOAN</strong>
            </p>
            <p>
              {`To help the government fight the funding of terrorism and money laundering activities, Federal law requires
              all financial institutions to obtain, verify, and record information that identifies each person who opens an
              account or applies for a loan. What this means for you: When you open an account or apply for a loan, we will
              ask for your name, street address, date of birth, tax identification number and other information that will
              allow us to identify you. We may also ask to see your driver's license, or other identifying documents.`}
            </p>
            <p>
              OH Residents: The Ohio laws against discrimination require that all creditors make credit equally available to
              all creditworthy customers, and that credit reporting agencies maintain separate credit histories on each
              individual upon request. The Ohio Civil Rights Commission administers compliance with this law.
            </p>
          </>
        )
      }
      <p>
        *Applications approved before 1 p.m. CT Monday-Friday, excluding federal holidays, are typically funded the same day.
        Applications approved later are generally funded the next business day. Funding timing depends on your bank.
        Approval may require additional verification, which could delay funding if not completed promptly.
      </p>

      <p>
        All NetCredit loans and lines of credit are offered
        &#32;
        <Link onDarkBg to={uiRoutes.legacyAH.lendingPartners}>
          by a member of the NetCredit family of companies or a lending partner bank.
        </Link>
        &#32;
        All open and active loans and lines of credit will be serviced by NetCredit.
      </p>

      <p>
        In states where NetCredit loans and lines of credit are offered by a lending partner bank, new loans and lines of
        credit are underwritten, approved, and funded by Quill Bank or Republic Bank &amp; Trust Company.
        Refer to the
        &#32;
        <Link onDarkBg to={uiRoutes.legacyAH.ratesAndTerms}>Rates &amp; Terms page</Link>
        &#32;
        for your state for more information.
      </p>

      <p>
        This website may utilize session replay technologies to collect, record and track data about how you interact with
        our website. By signing in or logging on to the netcredit.com website, you acknowledge and agree for NetCredit to
        utilize session replay technologies. Please visit our
        &#32;
        <Link onDarkBg to={uiRoutes.legacyAH.termsOfUse}>Terms of Use</Link>
        &#32;
        to learn more about how we utilize session replay technology to monitor and record interactions with our website.
      </p>

      <p>
        KS residents: NetCredit Loan Services, LLC, License No. SL.0026603.
      </p>

      <p className="copyright">
        &copy; {new Date().getFullYear()} NetCredit
      </p>
    </div>
  );
};
